import { render, staticRenderFns } from "./BooleanItem.vue?vue&type=template&id=00684474&scoped=true&"
import script from "./BooleanItem.vue?vue&type=script&lang=js&"
export * from "./BooleanItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00684474",
  null
  
)

export default component.exports